/** @format */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import GridItem from '../../../components/Grid/GridItem';
import Typography from '@material-ui/core/Typography';
import I18n from '../../../components/Translate/I18n';
import GridContainer from 'components/Grid/GridContainer.jsx';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import { DateHelper } from '../../../helpers/DateHelper';
import ActionButton from '../../../components/Buttons/CustomTextButton';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { operationOnSimcardActions, operationOnSimcardConstants } from '../../../modules/simcard/operationOnSimcard';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { componentDebug } from 'core/debug';
import { AlertDialog } from '../../lib/dialog/AlertDialog';

class IccidWaitForActivation extends PureComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            iccid: this.props.iccid,
            simCard: this.props.simCard,
            showActionButton: true,
            alertOpen: false,
            alertTitleDialog: null,
            alertDisplayMessage: null,
            alertConfirmCallback: () => {},
        };
    }

    confirmAction = (messageTitle, messageBody, callback) => {
        this.setState({
            alertOpen: true,
            alertTitleDialog: messageTitle,
            alertDisplayMessage: messageBody,
            alertConfirmCallback: callback,
        });
    };

    cancelActivationRequest = (simCard) => {
        componentDebug(simCard);
        this.setState({ showActionButton: false }, () => {
            const { dispatch } = this.props;
            const { simCard } = this.state;
            const params = {
                id: simCard.id,
                activationCancel: true,
            };
            dispatch(
                operationOnSimcardActions.put(
                    FormGeneralHelper.getUrl('/operation_on_sim_cards/' + simCard.id),
                    params,
                    operationOnSimcardConstants.SIM_CARD_CANCEL_ACTIVATION,
                    (data) => {
                        this.props.refreshPage();
                    },
                    { propagateDataToCallback: true }
                )
            );
        });
    };

    render() {
        const { simCard, showActionButton, alertOpen, alertTitleDialog, alertDisplayMessage, alertConfirmCallback } = this.state;
        return (
            <GridContainer>
                <GridItem xs={12}>
                    <Typography variant="subtitle2" gutterBottom>
                        <I18n trans="simcard:add.waiting_for_activation" />
                    </Typography>
                    {simCard.autoactivationdate && (
                        <Typography variant="subtitle2" gutterBottom>
                            <I18n trans="simcard:add.activation_date" />
                            {DateHelper.formatYYYYMMDD(simCard.autoactivationdate)}
                        </Typography>
                    )}
                </GridItem>
                <GridItem>
                    {showActionButton && (
                        <ActionButton
                            callback={() => {
                                this.confirmAction(
                                    'simcard:add.confirm_cancel_activate_sim_card',
                                    'simcard:add.confirm_cancel_activate_sim_card_description',
                                    () => {
                                        this.cancelActivationRequest(simCard);
                                    }
                                );
                            }}
                            callbackParam={simCard}
                            label="simcard:add.break_activation_request"
                            size="sm"
                        />
                    )}
                    <AlertDialog
                        open={alertOpen}
                        titleDialog={alertTitleDialog}
                        displayMessage={alertDisplayMessage}
                        closeCallback={() => {
                            this.setState({ alertOpen: false });
                        }}
                        confirmCallback={alertConfirmCallback}
                    />
                </GridItem>
            </GridContainer>
        );
    }
}

IccidWaitForActivation.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    return {
        ...state,
    };
};
const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(IccidWaitForActivation);
export default Enhance;
